import React from 'react';
import ForkliftAddEdit from './forklift-add-edit';
import ForkliftAddEditModal from './forklift-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { FORKLIFT_ADD_EDIT } = MODAL_TYPES;

const ForkliftModals = () => {
  return (
    <>
      <ForkliftAddEdit modalId={FORKLIFT_ADD_EDIT} />
      <ForkliftAddEditModal />
    </>
  );
};

export default ForkliftModals;
